import axios from 'axios';
import { auth0, redirectToLogin } from '@/auth0';

const setupAxiosRequestInterceptor = () => {
    axios.interceptors.request.use(async (config) => {
        if (!config.headers.Authorization && auth0.isAuthenticated.value) {
            try {
                const token = await auth0.getAccessTokenSilently();

                config.headers.Authorization = `Bearer ${token}`;
            } catch (error) {
                // getAccessTokenSilently delegates to auth0-spa-js's
                // getTokenSilently, which throws login_required/consent_required
                // when the session can't be refreshed silently; only then do we
                // bounce to login. Anything else is a real error, so rethrow it.
                // See: https://github.com/auth0/auth0-spa-js#getting-started
                if (error.error === 'login_required' || error.error === 'consent_required') {
                    await redirectToLogin(window.location.pathname + window.location.search);

                    throw new Error('Redirecting to login');
                }

                throw error;
            }
        }

        return config;
    });
};

const setupAxiosResponseInterceptor = (router) => {
    axios.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response && error.response.status === 401) {
                // Route through the logout page so the centralized logout logic
                // in the router guard runs (no need to call auth0.logout here).
                router.push({ name: 'logout' });
            }

            return Promise.reject(error);
        },
    );
};

export const setupInterceptors = (router) => {
    setupAxiosRequestInterceptor();

    setupAxiosResponseInterceptor(router);
};
